import React from 'react'

export const normalizeChildren = x => {
    if (null === x) {
        return []
    }
    else if (Array.isArray(x)) {
        return x
            .map(normalizeChildren)
            .flat()
            .filter(a => a)
    }
    else if ('string' === typeof x) {
        return [x]
    }
    else if (React.Fragment === x.type) {
        return normalizeChildren(x.props.children)
    }
    else {
        return [x.type(x.props)]
    }
}
